<template>
  <div style="margin: 10px;">
    <v-form
      direction="horizontal"
      :model="options"
      :rules="rules"
      ref="ruleForm"
    >
      <div style="text-align: left">
        <v-affix :offset-top="10">
          <v-button type="success" icon="save" @click.prevent="save('ruleForm')"
            >保存</v-button
          >
        </v-affix>
      </div>

      <v-form-item
        label="原密码"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        prop="ymm"
        has-feedback
        required
      >
        <v-input
          type="password"
          v-model="options.ymm"
          placeholder="原密码"
        ></v-input>
      </v-form-item>

      <v-form-item
        label="新密码"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        prop="mm"
        has-feedback
        required
      >
        <v-input
          type="password"
          v-model="options.mm"
          placeholder="新密码"
        ></v-input>
      </v-form-item>

      <v-form-item
        label="确认密码"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        prop="qrmm"
        has-feedback
        required
      >
        <v-input
          type="password"
          v-model="options.qrmm"
          placeholder="确认密码"
        ></v-input>
      </v-form-item>
    </v-form>
  </div>
</template>

<script>
let options = {

  ymm: "",
  mm: "",
  qrmm: "",

};

var validateLxdh = (rule, value, callback) => {
  if (value == "") {
    callback()
  }
  if (value.substring(0, 1) != '1' || value.length < 11) {

    callback(new Error('请输入正确的手机号码格式'));
  }
  else {
    callback()
  }
}

var validateMm = (rule, value, callback) => {
  var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  if (!reg.test(value)) {
    callback(new Error('密码格式必须大于8位并且由数字、字母及特殊字符组成'));
  }
  else {
    callback()
  }
}

var validateQrmm = (rule, value, callback) => {
  if (value != options.mm) {
    callback(new Error('两次密码需一致'));
  }
  else {
    callback()
  }
}
export default {
  data() {
    return {
      validateLxdh,
      validateMm,
      validateQrmm,
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      options,
      bm_options: [],
      rules: {
        ymm: [{
          required: true,
          message: '请输入原密码'
        }],
        mm: [{
          required: true,
          message: '请输入新密码'
        }, {
          validator: validateMm
        }],
        qrmm: [{
          required: true,
          message: '请输入确认密码'
        }, {
          validator: validateQrmm
        }]
      },
    };
  },
  created() {

  },
  methods: {

    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .get("api/system/qxgl/get-rywh-mmupdate", {params: this.options})
            .then((res) => {
              if (res.data.code == 200) {
                this.$message["success"](res.data.message);
                xadmin.close();
                // xadmin.father_reload();
              } else {
                this.$message["error"](res.data.message);
              }
            });

        }
      })
    }
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xgmm.vue